// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MatchStats_wrapper_3aXlu","scoreWrapper":"MatchStats_scoreWrapper_3HHFg"};